import storeRoot from '../store-root'
import http from '../../services/http'

const moduleName = 'deviceSettingsModule'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {

  },
  actions: {
    // 获取基地KeyValue 值
    async getBaseKeyValue ({commit}, payload) {
      let result = await http.get('/api/FishBase/KeyValue')
      return (result.data)
    },
    // 根据基地获取塘口值
    async getFishPond ({commmit}, payload) {
      let result = await http.get(`/api/FishPond/KeyValue/${payload}`)
      return (result.data)
    }
  },
  mutations: {
  }

})

export default moduleName
